import { createSlice } from "@reduxjs/toolkit";
import {
  getProducts,
  getProductById,
  addNewProduct,
  updateProduct,
  deleteProducts,
  getHotProducts,
} from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  products: [],
  error: {},
  product: null,
  hotProducts: [],
  loading: false,
  pagination: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  },
  paginationHot: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    totalOrdered: 0,
    totalReady: 0,
    totalCancelled: 0,
    totalPendingOrders: 0,
    totalActive: 0,
    totalInactive: 0,
    totalInStock: 0,
    totalOutOfStock: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalStockNotifications: 0,
    total: 0,
  },
};

const ProductsSlice = createSlice({
  name: "ProductsSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getProducts.pending, (state, action) => {
      state.loading = true;
      state.products = [];
      state.error = {};
    });

    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.products = action.payload.data;
      state.pagination = action.payload.pagination;
      state.loading = false;
    });

    builder.addCase(getProducts.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getHotProducts.pending, (state, action) => {
      state.loading = true;
      state.hotProducts = [];
      state.error = {};
    });

    builder.addCase(getHotProducts.fulfilled, (state, action) => {
      state.hotProducts = action.payload.data;
      state.paginationHot = action.payload.pagination;
      state.loading = false;
    });

    builder.addCase(getHotProducts.rejected, (state, action) => {
      state.error = action.error || null;
    });

    builder.addCase(getProductById.pending, (state, action) => {
      state.product = null;
      state.error = {};
    });

    builder.addCase(getProductById.fulfilled, (state, action) => {
      state.product = action.payload.data;
    });

    builder.addCase(getProductById.rejected, (state, action) => {
      // state.error = action.error || null;
    });

    builder.addCase(addNewProduct.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Adding Product...", {
        position: "top-center",
        autoClose: false,
      });
      state.product = null;
      state.error = {};
    });

    builder.addCase(addNewProduct.fulfilled, (state, action) => {
      state.products.push(action.payload);
    });

    builder.addCase(addNewProduct.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(updateProduct.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Product...", {
        position: "top-center",
        autoClose: false,
      });
     //       state.product = null;
      state.error = {};
    });

    builder.addCase(updateProduct.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) {
        toast.success("Product updated Successfully", {
          position: "top-center",
          autoClose: 500,
        });

        state.products = state.products.map((product) =>
          product.pro_id === action.payload.data.pro_id
            ? { ...product, ...action.payload.data }
            : product
        );
        state.product = action.payload.data;
      } else {
        toast.error("Product update Failed" + action.payload.message, {
          position: "top-center",
          autoClose: false,
          closeButton: true,
          closeOnClick: true,
        });
      }
    });

    builder.addCase(updateProduct.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(deleteProducts.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Deleting Product...", {
        position: "top-center",
        autoClose: false,
      });
      state.product = null;
      state.error = {};
    });

    builder.addCase(deleteProducts.fulfilled, (state, action) => {
      state.products = (state.products || []).filter(
        (product) =>
          product._id.toString() !== action.payload.product.toString()
      );
    });

    builder.addCase(deleteProducts.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  },
});

export default ProductsSlice.reducer;
